import React from "react";
import { connect } from "react-redux";

import { movil } from "../app-movil";
import { goTo } from "../tools";

const mapState = (state) => {
	return {
		loading: state.global.loading,
		email: state.registro.email,
		password: state.registro.password
	};
};

const mapDispatch = (dispatch) => {
	return {
		enviarLogin: (oMensaje) => {
			dispatch({ "type": "ENVIAR_MENSAJE_MOVIL", "mensaje": oMensaje});
		},
		limpiarRegistro: () => {
			dispatch({ "type": "LIMPIAR_REGISTRO" });
			dispatch({ "type": "LIMPIAR_REGISTRO_ASISTIDO" });
		}
	};
};

class Bienvenido extends React.Component {

	enviarLogin = () => {
		let mensaje = {"email": this.props.email, "password": this.props.password, "return": "autologin"};
		movil("registro", mensaje);
		
		this.props.limpiarRegistro();
		goTo("login");
		//self.window.location = "/#!/login";
	}
	
	render() {
		return <div className='text-content no-margin'>
			<div className="row">
				<div className="col" style={{"textAlign": "center"}}>
					<h3>Bienvenido</h3>
					<br />
				</div>
			</div>
			{/*<div className="row">
				<div className="col" style={{"textAlign": "center"}}>
					<img src={require("../img/vector_ok.png")} />
					<br />
				</div>
			</div>*/}
			<div className="row">
				<div className="col" style={{"textAlign": "center"}}>
					<h5>Tu información se ha guardado satisfactoriamente.</h5>
					<br />
				</div>
			</div>
			<div className="row">
				<div className="col" style={{"textAlign": "center"}}>
					<p>Recibirás un SMS con tu código de cliente, el cual se te solicitará para utilizar<br />los servicios de Call Center. De ahora en adelante deberás acceder a tu <br />sesión ingresando tu usuario y contraseña.</p>
				</div>
			</div>
			<div className="row">
				<div style={{"textAlign": "center"}}>
					<a onClick={this.enviarLogin} className="btn txt-orange">Iniciar Sesión</a>
				</div>
			</div>
			
		</div>;
	}
}

export default connect(mapState, mapDispatch)(Bienvenido);


// WEBPACK FOOTER //
// ./src/contrato/bienvenido.cmpt.js